// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"styles_Breadcrumb__ECBCq","item":"styles_item__bsSPJ"};